// extracted by mini-css-extract-plugin
export default {"home-orderStatusChat":"Home_home-orderStatusChat__Ofw1d"};